/**
 * 客户类型UI差异化渲染框架 - 组件导出
 */

import { App } from 'vue';
import ChartComponent from './ChartComponent.vue';
import DynamicTabPage from './DynamicTabPage.vue';
import { 
  DynamicComponent, 
  DynamicTabContent, 
  renderComponent, 
  evaluateCondition, 
  getNestedValue 
} from './ComponentFactory.js';

// 导入自定义组件
import SalesReportChart from '../components/SalesReportChart.vue';

// 销售型客户（经销商、药店）使用的组件
const salesComponents = {
  SalesReportChart
};

// 医疗机构（医院、诊所）使用的组件
const medicalComponents = {
  // 这里可以添加医疗机构特有的组件
};

// 注册所有组件
export function registerDynamicComponents(app: App) {
  app.component('chart-component', ChartComponent);
  app.component('dynamic-tab-page', DynamicTabPage);
  app.component('dynamic-component', DynamicComponent);
  app.component('dynamic-tab-content', DynamicTabContent);
  
  // 全局注册组件
  Object.entries(salesComponents).forEach(([name, component]) => {
    app.component(name, component);
  });
  
  Object.entries(medicalComponents).forEach(([name, component]) => {
    app.component(name, component);
  });
  
  console.log('已注册客户类型动态组件');
}

export {
  ChartComponent,
  DynamicTabPage,
  DynamicComponent,
  DynamicTabContent,
  renderComponent,
  evaluateCondition,
  getNestedValue
};

export default {
  install(app: App) {
    registerDynamicComponents(app);
  }
}; 